import React, { useState, useEffect } from "react";
// utils
import { FormikTextInput } from "../../inputs/FormikInputs";
import CommonForm from "../CommonForm";
import FormButton from "../../button/FormButton";
// functions
import { postMerchant, deleteMerchant, updateMerchant } from './MerchantsFunctions';
import { handleResponse } from "../../../../services/Local-services";
// validaciones
import { formikValidation } from './MerchantsFormValidaciones';
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, formIsOpen, rowSelected, snackbarData, formData } from '../../../../recoilState/GlobalState';

export default function MerchantsForm(props) {
    const [newMerchant, setNewMerchant] = useState({});
    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [selected, setSelected] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { titles, updateList, procede } = props.props;

    async function handleAction() {
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        if (procede === 'Deleteone') {
            const response = await deleteMerchant(credentials, selected.row, setInRequest);
            return handleResponse(response, 'Merchant eliminado exitosamente', functions);
        }
        if (procede === 'Addone') {
            const response = await postMerchant(credentials, newMerchant, setInRequest)
            return handleResponse(response, 'Merchant añadido exitosamente', functions);
        }
        if (procede === 'Editone') {
            const response = await updateMerchant(credentials, newMerchant, selected.row, setInRequest)
            return handleResponse(response, 'Merchant modificado exitosamente', functions);
        }
    };

    useEffect(() => {
        if (procede !== 'Deleteone') handleAction();
    }, [newMerchant])

    const formik = formikValidation(setNewMerchant, selected.row, titles);
    const disabled = inRequest || procede === 'Deleteone';

    return (
        <CommonForm
            onSubmit={formik.handleSubmit}
            title={data.title}
            procede={procede}
        >
            <FormikTextInput
                data={data}
                name='nombre'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='cuit'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='plan'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='rubro'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='acreditacion'
                formik={formik}
                disabled={disabled}
            />
            <FormButton
                inRequest={inRequest}
                handleAction={handleAction}
            />
        </CommonForm >
    );
};